(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-clickable-text-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordionItems = document.querySelectorAll('.accordion-item');
  const accordionImage = document.getElementById('accordion-image');
  const accordionBlockContainer = document.querySelector('.accordion-block-container');

  // Open the first accordion by default
  if (accordionItems.length > 0) {
    accordionItems[0].classList.add('active');
    accordionImage.src = accordionItems[0].getAttribute('data-image');
  }

  // Function to open the accordion by clicking the image
  function openAccordion(item) {
    // Remove 'active' class from all items
    accordionItems.forEach(i => i.classList.remove('active'));

    // Add 'active' class to the clicked item
    item.classList.add('active');

    // Change the accordion image
    accordionImage.src = item.getAttribute('data-image');
  }

  // Event listener for clicking on an accordion item
  accordionItems.forEach(item => {
    item.addEventListener('click', function() {
      openAccordion(this);
    });
  });

  // Add event listener to image container to track clicks on left-side images
  accordionImage.addEventListener('click', function() {
    // Get the active accordion item and move to the next one in the list
    let activeItem = document.querySelector('.accordion-item.active');
    let currentIndex = Array.from(accordionItems).indexOf(activeItem);
    let nextIndex = (currentIndex + 1) % accordionItems.length; // Loop back to the start if at the end

    // Open the next accordion
    openAccordion(accordionItems[nextIndex]);
  });
});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if ((scrollTop) < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      var megaMenuSelector = document.querySelectorAll(".mega-menu");
      megaMenuSelector.forEach(menu => menu.removeAttribute("open"));
      // this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-accordion"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const accordionItems = document.querySelectorAll('.accordion-row');
        const accordionImage = document.getElementById('accordion-image');
        const accordionBlockContainer = document.querySelector('.accordion-wrapper');
    
        // Open the first accordion by default
        if (accordionItems.length > 0) {
            accordionItems[0].classList.add('active');
            accordionImage.src = accordionItems[0].getAttribute('data-image');
        }
    
        // Function to open the accordion by clicking the image
        function openAccordion(item) {
            // Remove 'active' class from all items
            accordionItems.forEach(i => i.classList.remove('active'));
        
            // Add 'active' class to the clicked item
            item.classList.add('active');
        
            // Change the accordion image
            accordionImage.src = item.getAttribute('data-image');
        }
    
        // Event listener for clicking on an accordion item
        accordionItems.forEach(item => {
            item.addEventListener('click', function() {
                openAccordion(this);
            });
        });
    
        // Add event listener to image container to track clicks on left-side images
        accordionImage.addEventListener('click', function() {
            // Get the active accordion item and move to the next one in the list
            let activeItem = document.querySelector('.accordion-row.active');
            let currentIndex = Array.from(accordionItems).indexOf(activeItem);
            let nextIndex = (currentIndex + 1) % accordionItems.length; // Loop back to the start if at the end
        
            // Open the next accordion
            openAccordion(accordionItems[nextIndex]);
        });
    });

  } catch(e) { console.error(e); }
})();
})();
